import React from 'react';
import { GeographicBadge } from '../geografia/GeographicBadge';
import { Link } from 'react-router-dom';
import { X, Plus, Minus, ExternalLink, MapPin } from 'lucide-react';

export const ETAPA_LABELS = {
  nuevo: 'Nuevo', estudio: 'Estudio', mediacion: 'Mediación', en_gestion: 'En Gestión', oferta: 'Oferta',
  proceso_compra: 'Proceso compra', adquirido: 'Adquirido',
};
export const ESTADO_LABELS = { activo: 'Activo', standby: 'Standby', cerrado: 'Cerrado', papelera: 'Papelera' };

export const fuenteLabel = (f) => (
  f === 'acceso' ? 'Punto de acceso para visitas'
    : f === 'catastro_parcela' ? 'Ubicación de la parcela (Catastro)'
      : 'Coordenadas manuales'
);

const AssetRow = ({ a, selected, onToggle }) => (
  <div className="py-3 first:pt-0 last:pb-0" data-testid={`point-card-asset-${a.id}`}>
    <div className="flex items-start justify-between gap-3">
      <div className="min-w-0">
        <p className="text-sm font-semibold text-slate-900">{a.codigo_npl || 'Sin código'}</p>
        <p className="text-sm text-slate-700 break-words">{a.direccion || 'Sin dirección'}</p>
        <p className="text-xs text-slate-500">{[a.municipio, a.provincia].filter(Boolean).join(', ')}</p>
      </div>
      <button
        onClick={() => onToggle(a)}
        className={`shrink-0 text-xs font-medium flex items-center gap-1 rounded-md px-2.5 py-1.5 border transition-colors ${selected ? 'border-red-200 text-red-700 hover:bg-red-50' : 'border-blue-200 text-blue-700 hover:bg-blue-50'}`}
        data-testid={`point-card-toggle-${a.id}`}
      >
        {selected ? <><Minus className="w-3 h-3" /> Quitar</> : <><Plus className="w-3 h-3" /> Añadir a recorrido</>}
      </button>
    </div>
    <div className="flex flex-wrap gap-x-4 gap-y-1 mt-2 text-xs text-slate-600">
      <GeographicBadge geo={a.exclusion_geografica} id={`map-${a.id}`} />
      <span>Tipo: <strong className="text-slate-800">{a.tipo_activo || a.tipo_activo_operativo || '—'}</strong></span>
      <span>Estado: <strong className="text-slate-800">{ESTADO_LABELS[a.estado] || a.estado || '—'}</strong></span>
      <span>Fase: <strong className="text-slate-800">{ETAPA_LABELS[a.etapa_visual] || a.etapa_visual || '—'}</strong></span>
      <span>Mediador: <strong className="text-slate-800">{(a.mediadores || []).map(m => m.name).join(', ') || 'Sin asignar'}</strong></span>
    </div>
    <div className="flex items-center justify-between mt-2">
      <span className="text-[11px] text-slate-400 flex items-center gap-1"><MapPin className="w-3 h-3" />{fuenteLabel(a.fuente)}</span>
      <Link to={`/activos/${a.id}`} className="text-xs text-blue-700 hover:underline flex items-center gap-1" data-testid={`point-card-ficha-${a.id}`}>
        Ver ficha <ExternalLink className="w-3 h-3" />
      </Link>
    </div>
  </div>
);

// Tarjeta del marcador; si varios activos comparten coordenadas se listan todos.
export const PointCard = ({ group, selectedIds, onToggle, onClose }) => {
  if (!group) return null;
  return (
    <div className="absolute left-2 right-2 bottom-2 sm:left-auto sm:right-3 sm:bottom-3 sm:w-96 z-[500] bg-white rounded-xl shadow-xl border border-slate-200 max-h-[60%] flex flex-col" data-testid="point-card">
      <div className="flex items-center justify-between px-4 py-2.5 border-b border-slate-100">
        <p className="text-xs font-medium text-slate-500">
          {group.items.length > 1 ? `${group.items.length} activos en esta ubicación` : 'Activo'}
        </p>
        <button onClick={onClose} className="text-slate-400 hover:text-slate-700" data-testid="point-card-close"><X className="w-4 h-4" /></button>
      </div>
      <div className="px-4 py-3 overflow-y-auto divide-y divide-slate-100">
        {group.items.map(a => <AssetRow key={a.id} a={a} selected={selectedIds.has(a.id)} onToggle={onToggle} />)}
      </div>
    </div>
  );
};

export default PointCard;
